import SVGImage from '~/components/Image/SVGImage'
import useCurrentUser from '~/hooks/useCurrentUser'
import { useGetRewardsQuery } from '~/redux/apis/reward-api'

export default function XpPill(): React.ReactElement | null {
  const user = useCurrentUser()
  const { data: rewards } = useGetRewardsQuery(undefined, { skip: !user })

  if (rewards?.xp === undefined) return null

  return (
    <div className="hidden md:flex items-center gap-1.5 h-9 pl-3 pr-3.5 rounded-full bg-white-dim border border-solid border-yellow-gold-fade">
      <SVGImage alt="xp" height={18} imageClassName="w-4.5" loading="eager" srcKey="gamification/xp.svg" width={18} />
      <span className="text-base font-bold text-white">{rewards.xp.toLocaleString()}</span>
    </div>
  )
}
